import React from "react"
import { StyleSheet, View } from "react-native"
import { theme } from "@common/theme/theme"
import { brand } from "../../design-system/theme/tokens/colors"

/** Une heure dessinée dure soixante minutes. */
const HOUR_MINUTES = 60

/** Avec le masteur ; en entraînement (le violet du mode concentré, éclairci). */
export const HOUR_COLORS = {
    withMasteur: brand.marine,
    training: "#C6ADF7",
}

/** Le fond du temps d'entraînement : sa couleur de barre, très éclaircie. */
export const TRAINING_TINTS = { training: "#F3EDFE", beside: "#EDF0F8" }

const percent = (minutes) => `${(minutes / HOUR_MINUTES) * 100}%`

/**
 * L'heure de l'élève, en une barre — la signature d'un format, là où il se
 * nomme : marine quand le masteur est avec lui, violette quand il s'entraîne
 * de son côté. Un format où le masteur reste toute l'heure a une barre
 * pleine.
 *
 * C'est une jauge : un contour gris l'entoure, avec un jour entre lui et le
 * remplissage, pour qu'une barre pleine se lise encore comme une heure
 * remplie, pas comme un trait.
 *
 * `visits` : `[début, fin]` en minutes — les temps avec le masteur. `height`
 * est la hauteur de la jauge, contour compris.
 *
 * `muted` l'éteint (format verrouillé). Sans `alt`, la barre est décorative :
 * ses mots sont à côté.
 */
const HourBar = ({ visits = [], height = 20, muted = false, alt }) => (
    <View
        {...(alt
            ? { role: "img", "aria-label": alt }
            : { "aria-hidden": true })}
        style={[styles.frame, { height }, muted && styles.frameMuted]}
    >
        <View style={[styles.track, muted && styles.trackMuted]}>
            {visits.map(([start, end]) => (
                <View
                    key={start}
                    style={[
                        styles.visit,
                        { left: percent(start), width: percent(end - start) },
                        muted && styles.visitMuted,
                    ]}
                />
            ))}
        </View>
    </View>
)

const styles = StyleSheet.create({
    frame: {
        alignSelf: "stretch",
        borderRadius: 999,
        borderWidth: 1.5,
        borderColor: theme.colors.light,
        padding: 1.5,
        backgroundColor: theme.colors.white,
    },
    frameMuted: { borderColor: theme.colors.lightMore },
    track: {
        flex: 1,
        borderRadius: 999,
        overflow: "hidden",
        backgroundColor: HOUR_COLORS.training,
    },
    trackMuted: { backgroundColor: theme.colors.lightMore },
    // Des aplats bord à bord, pas des pastilles : une seule barre, remplie
    // tantôt d'une couleur, tantôt de l'autre.
    visit: {
        position: "absolute",
        top: 0,
        bottom: 0,
        backgroundColor: HOUR_COLORS.withMasteur,
    },
    visitMuted: { backgroundColor: theme.colors.light },
})

export default HourBar
